import React from "react";
import { Fragment } from "redux-little-router";
import Home from "../pages/Home";

//Pages
import PrivacyPolicy from "../pages/PrivacyPolicy";
import CookiePolicy from "../pages/CookiePolicy";
import FAQ from "../pages/FAQ";
import DataSafe from "../pages/DataSafe";
import YourRights from "../pages/YourRights";
import DataGlance from "../pages/DataGlance";
import NotFound from "./NotFound";

const Content = () => {
  return (
    <div className="content__wrapper">
      <Fragment forRoute="/">
        <div>
          <Fragment forRoute="/how-to-keep-your-data-safe">
            <DataSafe />
          </Fragment>
          <Fragment forRoute="/privacy-policy">
            <PrivacyPolicy />
          </Fragment>
          <Fragment forRoute="/cookie-policy">
            <CookiePolicy />
          </Fragment>
          <Fragment forRoute="/faq">
            <FAQ />
          </Fragment>
          <Fragment forRoute="/your-rights">
            <YourRights />
          </Fragment>
          <Fragment forRoute="/your-data-at-a-glance">
            <DataGlance />
          </Fragment>
          <Fragment forRoute="/">
            <Home />
          </Fragment>
          <Fragment forNoMatch>
            <NotFound />
          </Fragment>
        </div>
      </Fragment>
    </div>
  );
};

export default Content;



// WEBPACK FOOTER //
// ./src/components/common/Content.js